import React from "react";
import { Box, Image as Img, Text } from "@theme-ui/components";
import buildImageUrl from "../../lib/image-boss-helper";

const Image = ({ url, caption = false, insideGroup }) => {
  return (
    <Box>
      <Img
        src={buildImageUrl(url, 1200)}
        sx={{
          mb: insideGroup ? null : [2, 3],
          display: "block",
          borderRadius: [15, null, 30],
        }}
      />
      {caption && (
        <Text
          sx={{ fontSize: [1, 2] }}
          as="p"
          variant="paragraph"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
      )}
    </Box>
  );
};

export default Image;
